import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <section className="error-page section">
      <div className="error-container">
        <h2>Oops! it's a dead end</h2>
        <Link to="/" className="btn btn-primory">
          Home Page
        </Link>
      </div>
    </section>
  );
};

export default Error;
